import { cn } from "lib/utils";
import React from "react";

import checkInSuccess from "assets/images/totem/check-in-success.svg";
import clock from "assets/images/totem/clock.svg";
import confirmCheck from "assets/images/totem/confirm-check.svg";
import { TotemScheduling } from "store/ducks/totem-scheduling";
import { ActionButton } from "../ActionButton";
import { formatSchedulingTime } from "../SchedulingDetailsCard";
import { TotemHeader } from "../TotemHeader";

type Props = { scheduling: TotemScheduling; onFinish: () => void };

export const CheckInSuccessScreen: React.FC<Props> = ({
	scheduling,
	onFinish,
}) => (
	<main
		className={cn(
			"mx-auto flex min-h-full w-full max-w-[800px] flex-col items-center gap-14 bg-white px-6 pb-14 pt-8 max-[1023px]:px-5 max-[1023px]:pb-10 max-[1023px]:pt-6 max-[639px]:gap-8 max-[639px]:px-3 max-[639px]:pb-8 max-[639px]:pt-4",
		)}
	>
		<section
			className={cn(
				"relative min-h-[924px] w-full shrink-0 max-[639px]:min-h-[680px]",
			)}
		>
			<div
				className={cn(
					"absolute inset-x-0 top-14 flex min-h-[868px] flex-col items-center gap-6 bg-[#F3F4F6] px-14 pb-14 pt-24 text-center max-[1023px]:top-12 max-[1023px]:px-8 max-[1023px]:pb-10 max-[1023px]:pt-20 max-[639px]:top-10 max-[639px]:min-h-[620px] max-[639px]:gap-4 max-[639px]:px-4 max-[639px]:pb-6 max-[639px]:pt-16",
				)}
			>
				<img
					src={checkInSuccess}
					alt=""
					className={cn(
						"h-24 w-24 max-[639px]:h-16 max-[639px]:w-16",
					)}
				/>
				<h1
					className={cn(
						"w-full font-sans text-[32px] font-bold leading-normal text-[#1D293D] max-[639px]:text-[20px]",
					)}
				>
					Check-in realizado!
				</h1>
				<p
					className={cn(
						"w-full font-sans text-[24px] leading-normal text-[#45556C] max-[639px]:text-[14px]",
					)}
				>
					Sua chegada foi registrada com sucesso.
				</p>
				<div
					className={cn(
						"flex w-full items-start gap-4 bg-white p-6 text-left max-[639px]:gap-3 max-[639px]:p-4",
					)}
				>
					<img
						src={clock}
						alt=""
						className={cn(
							"h-8 w-8 shrink-0 max-[639px]:h-6 max-[639px]:w-6",
						)}
					/>
					<div className={cn("flex flex-col gap-2")}>
						<strong
							className={cn(
								"font-GilroyBold text-[24px] text-[#1E2939] max-[639px]:text-[18px]",
							)}
						>
							Aguardando liberação
						</strong>
						<span
							className={cn(
								"font-sans text-[20px] leading-normal text-[#45556C] max-[639px]:text-[14px]",
							)}
						>
							Permaneça na área de espera e aguarde as orientações
							da equipe.
						</span>
					</div>
				</div>
				<div
					className={cn(
						"relative w-full bg-white p-6 text-left before:absolute before:-top-2 before:left-0 before:right-0 before:h-4 before:bg-white before:[clip-path:polygon(0_0,4%_100%,8%_0,12%_100%,16%_0,20%_100%,24%_0,28%_100%,32%_0,36%_100%,40%_0,44%_100%,48%_0,52%_100%,56%_0,60%_100%,64%_0,68%_100%,72%_0,76%_100%,80%_0,84%_100%,88%_0,92%_100%,96%_0,100%_0,100%_100%,0_100%)]",
					)}
				>
					<div
						className={cn(
							"grid grid-cols-2 gap-6 max-[639px]:gap-3",
						)}
					>
						<div
							className={cn(
								"border-b border-[#E5E7EB] pb-4 max-[639px]:pb-2",
							)}
						>
							<span
								className={cn(
									"font-GilroySemibold text-[16px] uppercase tracking-[0.8px] text-[#6A7282] max-[639px]:text-[10px] max-[639px]:tracking-[0.4px]",
								)}
							>
								Placa
							</span>
							<p
								className={cn(
									"font-GilroyBold text-[24px] text-[#1E2939] max-[639px]:text-[16px]",
								)}
							>
								{scheduling.vehicle_plate || "—"}
							</p>
						</div>
						<div
							className={cn(
								"border-b border-[#E5E7EB] pb-4 max-[639px]:pb-2",
							)}
						>
							<span
								className={cn(
									"font-GilroySemibold text-[16px] uppercase tracking-[0.8px] text-[#6A7282] max-[639px]:text-[10px] max-[639px]:tracking-[0.4px]",
								)}
							>
								Ordem de coleta
							</span>
							<p
								className={cn(
									"font-GilroyBold text-[24px] text-[#1E2939] max-[639px]:text-[16px]",
								)}
							>
								{scheduling.id}
							</p>
						</div>
						<div className={cn("pt-4 max-[639px]:pt-2")}>
							<span
								className={cn(
									"font-GilroySemibold text-[16px] uppercase tracking-[0.8px] text-[#6A7282] max-[639px]:text-[10px] max-[639px]:tracking-[0.4px]",
								)}
							>
								Status
							</span>
							<p
								className={cn(
									"font-GilroyBold text-[24px] uppercase text-[#1E2939] max-[639px]:text-[16px]",
								)}
							>
								Check-in
							</p>
						</div>
						<div className={cn("pt-4 max-[639px]:pt-2")}>
							<span
								className={cn(
									"font-GilroySemibold text-[16px] uppercase tracking-[0.8px] text-[#6A7282] max-[639px]:text-[10px] max-[639px]:tracking-[0.4px]",
								)}
							>
								Chegada
							</span>
							<p
								className={cn(
									"font-GilroyBold text-[24px] text-[#1E2939] max-[639px]:text-[16px]",
								)}
							>
								{formatSchedulingTime(scheduling.starts_at)}
							</p>
						</div>
					</div>
				</div>
			</div>
			<TotemHeader />
		</section>
		<ActionButton iconSrc={confirmCheck} onClick={onFinish}>
			Finalizar
		</ActionButton>
	</main>
);
